import React, { Fragment } from 'react';

import { pushToGTMDataLayer } from '../../../utils/helpers';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  href?: string;
  text: string;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  dataMenuName?: string;
}

const Link: React.FC<LinkProps> = ({
  className = '',
  href,
  text,
  icon,
  iconPosition,
  dataMenuName,
  ...otherProps
}) => {
  const isButtonType = className ? className.split(' ').includes('mz-btn') : false;

  function handleTracking(e: React.MouseEvent<HTMLAnchorElement>) {
    const target = e.target as HTMLAnchorElement;
    if (target.getAttribute('data-menu-name')) {
      pushToGTMDataLayer({
        'Menu Item': target.getAttribute('data-menu-name'),
        'Form': target.getAttribute('data-form-name'),
        'Dealer': target.getAttribute('data-form-dealer'),
        'Action': target.getAttribute('data-form-event')
      });
    }
  }

  return (
    <a
      className={`mz-link ${className}`}
      href={href}
      onClick={handleTracking}
      {...otherProps}
    >
      {isButtonType ? (
        <Fragment>
          {icon && iconPosition === 'left' && icon}
          <span>{text}</span>
          {icon && iconPosition === 'right' && icon}
        </Fragment>
      ) : (
        text
      )}
    </a>
  );
};

export default Link;
